export default "__VITE_ASSET__CuFG9OgB__"